import { getSrcSet, largeWidth } from '../partials/image/image.utils';

export interface PageImage {
    host: string
    path: string
}

export const createImageAttributes = (pageImage:PageImage) => {
  const imageAspectRatioX = 16;
  const imageAspectRatioY = 9;
  const imageUrl = getSrcSet({ x: imageAspectRatioX, y: imageAspectRatioY }, pageImage.host, pageImage.path).large;
  const imageHeight = `${(Number(largeWidth) * imageAspectRatioY) / imageAspectRatioX}`;
  return {
    imageUrl,
    imageHeight,
    imageWidth: largeWidth,
  };
};
